export default __webpack_public_path__ + "static/media/step_img_4.0a7ac5d0.png";